import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}

interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const BinSVG: React.FunctionComponent<BinProps> = ({
  color = "#FFF",
  ...rest
}) => {
  return (
    <StyledContainer {...rest} data-testid="bin-container">
      <svg
        aria-hidden="true"
        focusable="false"
        data-icon="bin"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 20"
        width="100%"
        height="100%"
      >
        <title id="bin-svg">Bin svg</title>
        <path
          fill={color}
          d="M11.893 16.875h.643c.177 0 .321-.14.321-.313V5.938c0-.172-.144-.312-.321-.312h-.643c-.178 0-.322.14-.322.313v10.625c0 .172.144.312.322.312zm-6.429 0h.643c.178 0 .322-.14.322-.313V5.938c0-.172-.144-.312-.322-.312h-.643c-.177 0-.321.14-.321.313v10.625c0 .172.144.312.321.312zM17.68 2.5H13.5L12.15.75C11.786.278 11.214 0 10.607 0H7.393C6.786 0 6.214.278 5.85.75L4.5 2.5H.321C.144 2.5 0 2.64 0 2.813v.624c0 .173.144.313.321.313h.965v14.375c0 1.036.863 1.875 1.928 1.875h11.572c1.065 0 1.928-.84 1.928-1.875V3.75h.965c.177 0 .321-.14.321-.313v-.624c0-.173-.144-.313-.321-.313zm-10.8-1c.121-.157.312-.25.514-.25h3.214c.202 0 .393.093.514.25l.772 1H6.107l.772-1zm8.55 16.625c0 .345-.288.625-.643.625H3.214c-.355 0-.643-.28-.643-.625V3.75H15.43v14.375zm-6.75-1.25h.642c.178 0 .322-.14.322-.313V5.938c0-.172-.144-.312-.322-.312H8.68c-.178 0-.322.14-.322.313v10.625c0 .172.144.312.322.312z"
        ></path>
      </svg>
    </StyledContainer>
  );
};

export default BinSVG;
